import graphVrifyCode from "@/common/components/graph-vrifyCode/" // 图形验证码
import GDialog from "@/common/components/g-dialog/" // 弹框
import GHeader from '@/common/components/g-header/' // 头部
import refreshAcount from '@/common/components/refreshAcount/' // 刷新账户
import linksBanner from '@/common/components/links-banner/'
import noData from '@/common/components/noData/'
import loadMore from '@/common/components/load-more/'
import GCertificate from '@/common/components/g-certificate/'
import GTab from '@/common/components/g-tab/'
import GSearch from '@/common/components/g-search/'
import GButton from '@/common/components/g-button/'
import PHeader from '../views/components/p-header/'
import PCertificate from '../views/components/p-certificate/'

function plugin(Vue) {
	if (plugin.installed) {
		return
	}
	Vue.component('g-header', GHeader)
  Vue.component('g-vrifycode', graphVrifyCode)
  Vue.component('g-dialog', GDialog)
  Vue.component('refresh-acount', refreshAcount)
  Vue.component('links-banner', linksBanner)
  Vue.component('no-data', noData)
  Vue.component('load-more', loadMore)
  Vue.component('g-certificate', GCertificate)
  Vue.component('g-tab', GTab)
  Vue.component('g-search', GSearch)
  Vue.component('g-button', GButton)
  Vue.component('p-header', PHeader)
  Vue.component('p-certificate', PCertificate)
}

export default plugin



// WEBPACK FOOTER //
// ./src/pages/build821/utils/globalComponent.js